export const STARTED = 'request/STARTED'
export const SUCCEEDED = 'request/SUCCEEDED'
export const FAILED = 'request/FAILED'
export const ENDED = 'request/ENDED'
export const CLEAR_ERROR = 'request/CLEAR_ERROR'
